import React from 'react';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { momentParseDate } from '../../../../helpers';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import { MonthlyClosureDetailHistory, MonthlyClosureDetailHistoryFilters } from '../../../../app/models/MonthlyClosureDetailHistory';
import { User } from '../../../../app/models/User';

const formatCreatedUser = (createdUser?: string | User) => {
    if (typeof createdUser === 'string') return createdUser;
    if (!createdUser) return '';
    const nameParts = [createdUser.first_name, createdUser.last_name, createdUser.second_last_name]
        .filter(Boolean)
        .join(' ');
    return nameParts || createdUser.name || '';
};

interface Props {
    monthlyClosureDetailHistories: MonthlyClosureDetailHistory[];
    totalRows: number;
    filter: MonthlyClosureDetailHistoryFilters;
    setFilter: (filter: MonthlyClosureDetailHistoryFilters) => void;
    edit?: (id: number) => void;
    loading?: boolean;
}

const MonthlyClosureDetailHistoryDataTable = ({
    monthlyClosureDetailHistories,
    totalRows,
    filter,
    setFilter,
    edit,
    loading = false
}: Props) => {
    const columns = [
        {
            name: 'Fecha',
            selector: (row: any) => row?.created_at,
            sortable: true,
            sortField: 'created_at',
            width: '155px',
            cell: (row: MonthlyClosureDetailHistory) => (
                <span className="">{momentParseDate(row?.created_at, 'YYYY-MM-DD HH:mm')}</span>
            )
        },
        {
            name: 'Estado',
            selector: (row: any) => row?.status,
            sortable: true,
            sortField: 'status',
            cell: (row: MonthlyClosureDetailHistory) => <span className="">{row.status}</span>
        },
        {
            name: 'Creado por',
            selector: (row: any) => row.created_user,
            sortable: true,
            sortField: 'created_user',
            cell: (row: MonthlyClosureDetailHistory) => <span className="">{formatCreatedUser(row.created_user)}</span>
        },
        // {
        //     name: 'Acciones',
        //     selector: (row: any) => row?.id,
        //     sortable: false,
        //     width: '150px',
        //     cell: (row: ExpenseHistoryDataForm, index: any, column: any) => {
        //         return (
        //             <div className="">
        //                 {edit && !row.is_approved && (
        //                     <ButtonTableAction
        //                         callbackFunction={() => edit(row?.id ?? -1)}
        //                         classIcon={'mdi mdi-pencil'}
        //                         colorIcon={'text-warning'}
        //                         errorMessage={'No se puede editar este registro.'}
        //                         title={'Editar'}
        //                     />
        //                 )}
        //             </div>
        //         );
        //     }
        // }
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={monthlyClosureDetailHistories}
            progressPending={loading}
            isMobileStacked={true}
            paginationTotalRows={totalRows}
            filter={filter}
            setFilter={setFilter}
        />
    );
};

export default MonthlyClosureDetailHistoryDataTable;
